import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DiscussionActivityModel } from '@smarttask-common/src/lib/models/Discussion/Activity/Core/DiscussionActivityModel';

export enum DiscussionActivityActionTypes {
    ADD_DISCUSSION_ACTIVITY = '[DiscussionActivity] Create DiscussionActivity',
    ADD_DISCUSSION_ACTIVITYS = '[DiscussionActivity] Add DiscussionActivitys',
    UPSERT_DISCUSSION_ACTIVITY = '[DiscussionActivity] Upsert DiscussionActivity',
    UPSERT_DISCUSSION_ACTIVITYS = '[DiscussionActivity] Upsert DiscussionActivitys',
    UPDATE_DISCUSSION_ACTIVITY = '[DiscussionActivity] Update DiscussionActivity',
    UPDATE_DISCUSSION_ACTIVITYS = '[DiscussionActivity] Update DiscussionActivitys',
    DELETE_DISCUSSION_ACTIVITY = '[DiscussionActivity] Delete DiscussionActivity',
    DELETE_DISCUSSION_ACTIVITYS = '[DiscussionActivity] Delete DiscussionActivitys',
    DELETE_ALL_DISCUSSION_ACTIVITYS = '[DiscussionActivity] Delete All DiscussionActivitys',
    DELETE_ALL = '[DiscussionActivity] Delete All',

    UPDATE_SELECTED_ID = '[discussionActivity] Update SelectedId',
}

export class UpdateSelectedDiscussionActivityId implements Action {
    readonly type = DiscussionActivityActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_activity_id: string) {}
}

export class AddOne implements Action {
    readonly type = DiscussionActivityActionTypes.ADD_DISCUSSION_ACTIVITY;
    constructor(public discussionActivity: DiscussionActivityModel) {}
}

export class AddMany implements Action {
    readonly type = DiscussionActivityActionTypes.ADD_DISCUSSION_ACTIVITYS;
    constructor(public discussionActivitys: Array<DiscussionActivityModel>) {}
}

export class UpsertOne implements Action {
    readonly type = DiscussionActivityActionTypes.UPSERT_DISCUSSION_ACTIVITY;

    constructor(public discussionActivity: DiscussionActivityModel) {}
}

export class UpsertMany implements Action {
    readonly type = DiscussionActivityActionTypes.UPSERT_DISCUSSION_ACTIVITYS;
    constructor(public discussionActivitys: Array<DiscussionActivityModel>) {}
}

export class UpdateOne implements Action {
    readonly type = DiscussionActivityActionTypes.UPDATE_DISCUSSION_ACTIVITY;
    constructor(public discussionActivity: Update<DiscussionActivityModel>) {}
}

export class UpdateMany implements Action {
    readonly type = DiscussionActivityActionTypes.UPDATE_DISCUSSION_ACTIVITYS;
    constructor(public discussionActivitys: Array<Update<DiscussionActivityModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = DiscussionActivityActionTypes.DELETE_DISCUSSION_ACTIVITY;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = DiscussionActivityActionTypes.DELETE_DISCUSSION_ACTIVITYS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = DiscussionActivityActionTypes.DELETE_ALL_DISCUSSION_ACTIVITYS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = DiscussionActivityActionTypes.DELETE_ALL;
    constructor() {}
}

export type DiscussionActivityActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedDiscussionActivityId;
